import {createAction} from '@reduxjs/toolkit'
import {UpdateSiteSettingsResponse} from '@wix/ambassador-wix-events-web/types'
import {createAsyncAction} from '../../components/details-page/Widget/services/redux-toolkit'
import {SiteSettingsSettings} from '../types/state'

export const setSiteSettings = createAction<SiteSettingsSettings>('SET_SITE_SETTINGS')

export const getSiteSettings = createAsyncAction<any>('GET_SITE_SETTINGS', async (_, {extra: {serverApi}}) =>
  serverApi.getSiteSettings(),
)

export const updateSiteSettings = createAsyncAction<UpdateSiteSettingsResponse, Partial<SiteSettingsSettings>>(
  'UPDATE_SITE_SETTINGS',
  async (payload, {getState, extra: {serverApi}}) => {
    const settings = {...getState().siteSettings.settings, ...payload}

    return serverApi.updateSiteSettings(settings)
  },
)
